import styled from '@emotion/styled';

import { ThumbImageLayoutMode } from './index.types';

export const ThumbImage = styled.img<{
  layoutMode: ThumbImageLayoutMode;
  imageObjectFit: 'contain' | 'cover';
}>`
  display: block;
  object-fit: ${({ imageObjectFit }) => imageObjectFit};

  -webkit-user-drag: none;

  user-select: none;

  ${({ layoutMode }) =>
    layoutMode === 'fluid' &&
    `
    width: 100%;
    height: auto;
  `}

  ${({ layoutMode }) =>
    layoutMode === 'fill' &&
    `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `}
`;
